function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#20323c",
  d: "M13.015 13.806H7.578a.712.712 0 01-.713-.713V7.66c0-.394.319-.713.713-.713h5.44v.002c.393 0 .712.319.712.711v5.434a.712.712 0 01-.712.712zm7.57-6.875l-5.854-5.854-.006.003a3.436 3.436 0 00-.994-.692v.008A3.397 3.397 0 0012.3.08H8.287a3.42 3.42 0 00-2.398.979h-.002L.955 5.988l.002.008A3.418 3.418 0 000 8.371V19.25a3.42 3.42 0 001.053 2.47l-.003.007 4.349 4.348.003-.002a.856.856 0 001.449-.467l.014-.001v-4.216h.001c0-.393.32-.712.713-.712H12.3c.95 0 1.81-.387 2.43-1.01l.008.002 4.796-4.796.001-.011c.05-.048.097-.101.144-.152l.907-.91z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#48a894",
  d: "M20.59 13.805h6.85L20.59 6.94z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#20323c",
  d: "M27.439 24.49l-.001-.02V13.8h-6.85v10.67a1.716 1.716 0 001.71 1.857h3.431c.907 0 1.648-.704 1.71-1.595z"
});

const SvgProfitwell = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 27,
  viewBox: "0 0 28 27",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfitwell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/profitwell.cefd0966.svg";
export { ForwardRef as ReactComponent };